import { render, staticRenderFns } from "./JobCategory.vue?vue&type=template&id=d39dac32&scoped=true&"
import script from "./JobCategory.vue?vue&type=script&lang=js&"
export * from "./JobCategory.vue?vue&type=script&lang=js&"
import style0 from "./JobCategory.vue?vue&type=style&index=0&id=d39dac32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39dac32",
  null
  
)

export default component.exports